import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getDefaultTeamQueryOptions } from '@/features/users/api/getDefaultTeam';
import { getSessionQueryOptions } from '@/hooks/useSession';
import { api } from '@/lib/api-client';
import type { MutationConfig } from '@/lib/react-query';
import type { SessionData, User } from '@/types';

export const login = ({
  data,
}: {
  data: Partial<User>;
}): Promise<SessionData> => {
  return api.post(`/auth/login`, data, {
    withCredentials: true,
  });
};

type UseLoginOptions = {
  mutationConfig?: MutationConfig<typeof login>;
};

export const useLogin = ({ mutationConfig }: UseLoginOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getSessionQueryOptions().queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: getDefaultTeamQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: login,
  });
};
